/**
 * @module MessageCard
 */

import Component from '../base/Component';
import './styles.css';
import '../../scripts/picture';

/**
 * Раздел UI Kit.
 */
export default class MessageCard extends Component {
    static className = 'message-card';

    initElements() {
        this.elements = {};
    }

    init(options) {
        super.init(options);
    }
}
